import React, { useState, useEffect } from "react";
import OnBoardMenu from "../components/OnBoardMenu";
import useDropdownData from "../fetches/loadDropDownData";
import { columnMeta } from "../config/tableColumns";
import "../App.css";
import HrTable from "../tables/HrTable";

/**
 * The main Summary Table page that configures and renders the SummaryTable component
 */
const HrTablePage = () => {
  // Set document title
  useEffect(() => {
    document.title = "SUMISNI";
  }, []);

  // Column visibility state
  const [columnVisibility, setColumnVisibility] = useState({
    // Default column visibility state
    P01_0: true,
    P01_1: true,
    P01_2: true,
    P01_3: true,
    P01_4: true,
    P02_0: true,
    P02_1: true,
    P03_0: true,
    P03_1: true,
    P04_0: true,
    P04_1: true,
    P05_0: true,
    P05_1: true,
    P06_0: true,
    P06_1: true,
    P07_0: true,
    P07_1: true,
    P07_2: true,
    P08_0: true,
    P08_1: true,
    P09_0: true,
    P09_1: true,
    P10_0: true,
    P10_1: true,
    P11_0: true,
    P11_1: true,
    output: false,
  });

  // Filter state
  const [filters, setFilters] = useState({ filter: "" });

  // Table display options
  const [columnsVisible, setColumnsVisible] = useState(true);
  const [headersRotated, setHeadersRotated] = useState(false);
  const [dataEncrypted, setDataEncrypted] = useState(false);

  // Column pinning
  const [pinnedColumns, setPinnedColumns] = useState([]);

  // Sorting state
  const [sorting, setSorting] = useState(null);

  // Fetch dropdown data for filters
  const { dropdownData } = useDropdownData();

  // Handle search function
  const handleSearch = (searchQuery) => {
    setFilters((prev) => ({ ...prev, filter: searchQuery }));
  };

  // Define columns for the summary table
  // This is where you can configure different column sets for different tables
  const mainTableColumns = [
    "actions",
    "rating",
    "status",
    "code",
    "first_name",
    "last_name",
    "company",
    "team",
    "department",
    "division",
    "position",
    "date_of_interview",
    "date_of_translate",
    "date_of_offer",
    "date_of_fired",
    "commentary",
    "working_phone",
    "phone_number",
    "email",
    "NDA_date",
    "FB_IG",
    "linkedin",

    // Add the output column to show calculations
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <div className="header-container">
        <OnBoardMenu
          handleSearch={handleSearch}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
          columnMeta={columnMeta}
        />
      </div>

      {/* Main Content */}

      {/* Summary Table */}
      <div className="bg-white rounded-lg shadow">
        <HrTable
          filter={filters}
          columnsVisible={columnsVisible}
          headersRotated={headersRotated}
          dataEncrypted={dataEncrypted}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
          pinnedColumns={pinnedColumns}
          setPinnedColumns={setPinnedColumns}
          sorting={sorting}
          setSorting={setSorting}
          columns={mainTableColumns} // Pass the custom columns configuration
        />
      </div>
    </div>
  );
};

export default HrTablePage;
